import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto'
    }
  },
  deletePaper: {
    backgroundColor: theme.palette.background.default,

    margin: 'auto',
    width: '60%',
    minWidth: 800,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      minWidth: 'unset',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  deleteIcon: {
    margin: 'auto',
    fontSize: 80,
    position: 'absolute',
    backgroundColor: theme.palette.type === 'dark' ? '#121212' : '#7f7f7f',
    padding: 10,
    borderRadius: '50%',
    top: -42,
    color: theme.palette.primary.dark,
    left: 'calc(50% - 40px)'
  },
  title: {
    marginTop: 30,
    textAlign: 'center',
    marginBottom: 24
  },
  description: {
    textAlign: 'center',
    marginBottom: 8
  },
  deleteButton: {
    // backgroundColor: 'red',
    // color: 'white',
    marginLeft: 8
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  tableRow: {
    display: 'flex',
    alignItems: 'center',
    // '&>div': {
    //   backgroundColor: 'white',
    //   padding: 12
    // },
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#f0f0f0'
    }
  },
  tableRowMobile: {
    paddingTop: 10,
    paddingBottom: 10,
    borderTop: '1px solid gray'
  },
  expireDateCell: {
    flex: 3
  },
  APIKeyCell: {
    flex: 7,
    display: '-webkit-box',
    lineClamp: 1,
    boxOrient: 'vertical',
    overflow: 'hidden',
    position: 'relative'
  },
  APIKeyCellMobile: {
    background: '#dddddd',
    border: '1px solid gray',
    padding: 4,
    borderRadius: 8,
    marginBottom: 8
  },
  descriptionCell: {
    flex: 7
  },
  deleteIconCell: {
    flex: 1
  },
  deleteIconCellMobile: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& button': {
      backgroundColor: 'red',
      color: 'white'
    }
  },
  tableHead: {
    display: 'grid',
    gridTemplateColumns: '3fr 7fr 7fr 1fr',
    alignItems: 'center',
    padding: '6px 0 6px 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: '#f7f7f7',
    borderRadius: 12
  },
  copyIconButton: {
    position: 'absolute',
    top: -10,
    right: '12%',
    '& svg': {
      fontSize: 20
    }
  },
  copyIconButtonMobile: {
    position: 'absolute',
    backgroundColor: '#dddddd',
    top: -8,
    right: 0,
    '& svg': {
      fontSize: 20
    }
  },
  skeleton: {
    marginTop: '14px!important',
    marginBottom: '14px!important',
    width: '80%'
  }
}))

export default useStyles
